import { createRoute } from '@tanstack/react-router'
import rootRoute from '../rootRoute'
import AdminTabs from './AdminTabs'
import AdminSnapshots from '@/components/admin/SnapshotsList'
import { adminRouteLoader } from '@/lib/auth'
import { spacing } from '@/components/ui'

function AdminView() {
  return (
    <div
      style={{
        maxWidth: 'var(--container-max)',
        margin: '0 auto',
        padding: 'var(--space-8) var(--gutter) var(--space-20)',
      }}
    >
      <AdminTabs />
      <div className="oumma-overline" style={{ marginBottom: spacing.sm }}>
        Espace admin
      </div>
      <h1 style={{ fontSize: 'var(--text-h1)', margin: '0 0 28px' }}>
        Système
      </h1>

      <h2 style={{ fontSize: 'var(--text-h3)', marginBottom: spacing.md }}>
        Snapshots
      </h2>
      <AdminSnapshots />
    </div>
  )
}

export const adminScrapersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/view',
  loader: adminRouteLoader,
}).lazy(() => import('./AdminView.lazy').then((m) => m.Route))

export default AdminView
